<div class="bpz-input-wrapper">
  <!-- Label -->
  <label
    *ngIf="showLabel"
    class="bpz-input-label"
  >
    {{ label }}
  </label>

  <!-- Input with / without icons -->
  <ng-container *ngIf="hasIcon; else noIconInput">
    <div class="bpz-input-icon">
      <!-- Left icon -->
      <span *ngIf="showLeftIcon && leftIcon" class="bpz-input-icon-left">
        <lucide-icon [name]="leftIcon"></lucide-icon>
      </span>

      <input
        class="bpz-input"
        [ngClass]="[sizeClass, stateClass]"
        [type]="type"
        [placeholder]="placeholder"
        [disabled]="isDisabled"
        [value]="value"
        [attr.min]="min"
        [attr.max]="max"
        (focus)="onFocus()"
        (blur)="onBlur()"
        (input)="onInput($event.target.value)"
      />

      <!-- Right icon -->
      <span *ngIf="showRightIcon && rightIcon" class="bpz-input-icon-right">
        <lucide-icon [name]="rightIcon"></lucide-icon>
      </span>
    </div>
  </ng-container>

  <!-- Input without icon -->
  <ng-template #noIconInput>
    <input
      class="bpz-input"
      [ngClass]="[sizeClass, stateClass]"
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="isDisabled"
      [value]="value"
      [attr.min]="min"
      [attr.max]="max"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="onInput($event.target.value)"
    />
  </ng-template>

  <!-- Hint / error message -->
  <span
    *ngIf="state === InputStateEnum.ERROR && hint"
    class="bpz-input-error-message"
  >
    {{ hint }}
  </span>

  <mat-hint *ngIf="state !== InputStateEnum.ERROR && hint">
    {{ hint }}
  </mat-hint>
</div>
